import { IPermission, Permission } from "@edgetier/watchtower-types";
import { EDIT_INTERACTION_TAGS_ENABLED } from "constants/feature-flags";

/**
 *
 * @param usersPermissions The permissions that the user has.
 * @returns True if the user can manage phrase triggers. If the user has permission to manage interaction tags, return
 * true or false based on the EDIT_INTERACTION_TAGS_ENABLED feature flag.
 */
export const checkPermissionsAndFlag = (usersPermissions: IPermission[]) => {
    if (usersPermissions.some(({ permissionId }) => permissionId === Permission.ManagePhraseTriggers)) {
        return true;
    }
    // Even if the user has permission to manage tags, don't allow them to unless the feature flag is true.
    if (usersPermissions.some(({ permissionId }) => permissionId === Permission.ManageInteractionTags)) {
        return EDIT_INTERACTION_TAGS_ENABLED;
    }

    return usersPermissions.length > 0;
};
